var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          staticClass: "Weforsys-messageList Weforsys-common-drawer",
          attrs: {
            title: "站内消息",
            visible: _vm.drawer,
            direction: "rtl",
            size: "280px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tool" },
            [
              _c(
                "el-link",
                {
                  attrs: { underline: false },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.readAll($event)
                    },
                  },
                },
                [_vm._v("全部已读")]
              ),
              _c(
                "el-link",
                {
                  attrs: { underline: false },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.gotoCenter($event)
                    },
                  },
                },
                [_vm._v("消息中心")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading && _vm.listQuery.currentPage == 1,
                  expression: "loading && listQuery.currentPage == 1",
                },
              ],
              ref: "messageListBody",
              staticClass: "Weforsys-messageList-box",
            },
            [
              _vm.list.length
                ? _c(
                    "div",
                    _vm._l(_vm.list, function (item, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "Weforsys-messageList-item",
                          attrs: { title: item.title },
                          on: {
                            click: function ($event) {
                              return _vm.readInfo(item)
                            },
                          },
                        },
                        [
                          _c(
                            "el-badge",
                            {
                              attrs: {
                                "is-dot": "",
                                hidden: item.isRead == "1",
                                type: "warning",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-chat-dot-square Weforsys-messageList-item-icon",
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "Weforsys-messageList-txt" },
                            [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                              _c("p", { staticClass: "name" }, [
                                _c("span", [_vm._v(_vm._s(item.creatorUser))]),
                                _c("span", { staticClass: "time" }, [
                                  _vm._v(_vm._s(item.lastModifyTime)),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("p", { staticClass: "noData-txt" }, [
                    _vm._v(_vm._s(_vm.$t("common.noData"))),
                  ]),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "Weforsys-dialog Weforsys-dialog_center",
          attrs: {
            title: "查看消息",
            "close-on-click-modal": false,
            visible: _vm.visible,
            "lock-scroll": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "notice-wapper",
            },
            [
              _c("h1", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.info.title)),
              ]),
              _c("div", { staticClass: "info" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("toDate")(_vm.info.lastModifyTime))),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.info.creatorUser))]),
              ]),
              _c("div", {
                staticClass: "main",
                domProps: { innerHTML: _vm._s(_vm.info.bodyText) },
              }),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancelButton")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }